import $ from "jquery";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function openPopup($el) {
  var data = $el.data('popup');
  $(data).addClass('show');
  disableBodyScroll(document.querySelector('.section--popup'));
}


function closePopup($el) {
  $el.removeClass('show');
  enableBodyScroll(document.querySelector('.section--popup'));
  var popupName = $el.attr('data-popup-name');
  var cookieExpiration = $el.attr('data-cookie-expiration');
  // console.log(popupName);
  setCookie('popup-' + popupName, true, parseInt(cookieExpiration));
}

$('body').on('click', '[data-popup]', function(e){
  e.preventDefault();
  openPopup($(this));
});

$('.popup-close').on('click', function(){
  closePopup($(this).closest('.section--popup'));
});

$('.popup-btn-close').on('click', function(){
  closePopup($(this).closest('.section--popup'));
});

$('.button-popup-close').on('click', function(){
  closePopup($(this).closest('.section--popup'));
});

$('.popup-btn-close-link').on('click', function(){
  closePopup($(this).closest('.section--popup'));
});

$('.section--popup').on('click', function(){
  closePopup($(this));
});

$('.popup').on('click', function(el){
  el.stopPropagation();
});

$('.section--popup').each(function(){
  var $this = $(this);
  var dataTimer = $(this).attr('data-timer');
  var dataDisplayTime = $(this).attr('data-display-time');
  var popupName = 'popup-' + $(this).attr('data-popup-name');
  if(dataTimer == 1) {
    setTimeout(function(){
      // console.log('ksdfjl', popupName);
      var cookie = getCookie(popupName);
      // console.log('cookie', cookie);
      // console.log('getCookie', getCookie(popupName));
      if(cookie !== 'true') {
        $this.addClass('show');
      }
    }, parseInt(dataDisplayTime));
  }
});





//

// function closeCookiePopup() {
//   var cookie = getCookie('popup-cookies');
//   if(cookie != 'true') {
//     setCookie('popup-cookies', true, parseInt(30));
//     $('.section--popup--cookies').css('display', 'none');
//   }
// }

// closeCookiePopup();

// $('.section--popup--cookies .popup-close').on('click', function(){
//   closeCookiePopup();
// });